import React, { useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ButtonGroup from './ButtonGroup';
import { useOwlApcContext } from './OwlApcProvider';
import ErrorSave from './ErrorSave';
import Loading from './Loading';

function formatPhone(phone) {
  if (!phone) return phone;
  if (typeof phone !== 'string') return phone;
  const m = phone.match(
    /[+]?0?1?\(?(\d{3})\)? ?[.-]? ?(\d{3}) ?[.-]? ?(\d{4})(.*)/
  );
  if (!m || !m[1] || !m[2] || !m[3]) return phone;
  return `${m[1]}-${m[2]}-${m[3]}${m[4] || ''}`;
}

export const WelcomeEdit = ({
  address,
  setAddress,
  textOK,
  setTextOK,
  setEditing,
  setConfirmed,
  id,
  skey
}) => {
  const [editAddress, setEditAddress] = useState({ ...address });
  const [editTextOK, setEditTextOK] = useState(textOK);
  const { welcomeHandler } = useOwlApcContext();
  const [error, setError] = useState(false);
  const [saving, setSaving] = useState(false);

  if (saving) {
    return <Loading msg="Saving your response ..." />;
  }
  return (
    <>
      {error && <ErrorSave />}
      <h4>Update Job Site Address &amp; Contact Info</h4>
      <Row>
        <Col lg={12}>
          <Form.Group className="form-group">
            <Form.Label>Your Name</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="contact-name"
              value={editAddress.contactName}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, contactName: target.value });
              }}
            />
          </Form.Group>
        </Col>
        <Col lg={12}>
          <Form.Group className="form-group">
            <Form.Label>Address Line 1</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="address-line1"
              value={editAddress.addressLine1}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, addressLine1: target.value });
              }}
            />
          </Form.Group>
        </Col>
        <Col lg={12}>
          <Form.Group className="form-group">
            <Form.Label>Address Line 2</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="address-line2"
              value={editAddress.addressLine2 || ''}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, addressLine2: target.value });
              }}
            />
          </Form.Group>
        </Col>
        <Col lg={12}>
          <Form.Group className="form-group">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="city"
              value={editAddress.city}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, city: target.value });
              }}
            />
          </Form.Group>
        </Col>
        <Col lg={6}>
          <Form.Group className="form-group">
            <Form.Label>State</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="state"
              label="State"
              value={editAddress.state}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, state: target.value });
              }}
            />
          </Form.Group>
        </Col>
        <Col lg={6}>
          <Form.Group className="form-group">
            <Form.Label>Zip</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="zip"
              label="Zip"
              value={editAddress.zip}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, zip: target.value });
              }}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col lg={6}>
          <Form.Group className="form-group">
            <Form.Label>Mobile Phone</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="cell"
              value={editAddress.cell}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, cell: target.value });
              }}
              onBlur={({ target }) => {
                setEditAddress({
                  ...editAddress,
                  cell: formatPhone(target.value)
                });
              }}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="d-flex align-items-center">
          <Form.Group>
            <Form.Check
              type="checkbox"
              id="textOK"
              label="OK to text this number"
              checked={editTextOK}
              onChange={({ target }) => setEditTextOK(!!target.checked)}
              inline
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col lg={6}>
          <Form.Group className="form-group">
            <Form.Label>Additional Phone 1</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="otherPhone"
              label="Additional Phone 1"
              value={editAddress.phone}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, phone: target.value });
              }}
              onBlur={({ target }) => {
                setEditAddress({
                  ...editAddress,
                  phone: formatPhone(target.value)
                });
              }}
            />
          </Form.Group>
        </Col>
        <Col lg={6}>
          <Form.Group className="form-group">
            <Form.Label>Additional Phone 2</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="otherPhone2"
              label="Additional Phone 2"
              value={editAddress.phone2}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, phone2: target.value });
              }}
              onBlur={({ target }) => {
                setEditAddress({
                  ...editAddress,
                  phone2: formatPhone(target.value)
                });
              }}
            />
          </Form.Group>
        </Col>
        <Col xs={12}>
          <Form.Group className="form-group">
            <Form.Label>Email (needed for warranty information)</Form.Label>
            <Form.Control
              type="text"
              className="form-control"
              id="email"
              value={editAddress.email}
              onChange={({ target }) => {
                setEditAddress({ ...editAddress, email: target.value });
              }}
            />
          </Form.Group>
        </Col>

        {/* <Col xs={12}>
          <Form.Group className="form-group">
            <Form.Label>
              Please add additional decision makers and their contact info below
            </Form.Label>
            <Form.Control
              as="textarea"
              className="form-control"
              id="comments"
              value={comments}
              onChange={({ target }) => {
                setJob({ ...job, comments: target.value });
              }}
              type="textarea"
              rows={3}
            />
          </Form.Group>
        </Col> */}

        <ButtonGroup
          primaryFunc={async () => {
            setError(false);
            setAddress(editAddress);
            setTextOK(editTextOK);
            setSaving(true);
            const result = await welcomeHandler(
              { address: editAddress, textOK: editTextOK },
              { id, skey }
            );
            setSaving(false);
            if (result) {
              setEditing(false);
              setConfirmed(true);
            } else {
              setError(true);
            }
          }}
          primaryText="Save Changes"
          secondaryFunc={() => {
            setEditing(false);
          }}
          secondaryText="Cancel"
        />

        {error && <ErrorSave />}

        {/* <Col xs={12} justify="center" className="action-wrapper">
          <Button
            color="primary"
            type="submit"
            onClick={() => {
              handleConfirm(doFormats());
            }}
          >
            Update and Save Information
          </Button>
        </Col> */}
      </Row>
    </>
  );
};

WelcomeEdit.propTypes = {
  address: PropTypes.object,
  setAddress: PropTypes.func,
  textOK: PropTypes.bool,
  setTextOK: PropTypes.func,
  setEditing: PropTypes.func,
  setConfirmed: PropTypes.func,
  id: PropTypes.string,
  skey: PropTypes.string
};

export default WelcomeEdit;
